import { render, staticRenderFns } from "./GlobalSideBarMenu.vue?vue&type=template&id=01fb76f7&scoped=true&"
import script from "./GlobalSideBarMenu.vue?vue&type=script&lang=js&"
export * from "./GlobalSideBarMenu.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSideBarMenu.vue?vue&type=style&index=0&id=01fb76f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb76f7",
  null
  
)

export default component.exports